import { render, staticRenderFns } from "./sbList.vue?vue&type=template&id=80698cfa&"
import script from "./sbList.vue?vue&type=script&lang=js&"
export * from "./sbList.vue?vue&type=script&lang=js&"
import style0 from "./sbList.vue?vue&type=style&index=0&id=80698cfa&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports